import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, message } from 'antd';
import { ColaboradoresScroll } from './apontamentoProducao.styled';
import clipboard from '../../../services/util/clipboard';

/**
 * Modal para exibir cooperados duplicados na importação.
 */
export function ModalDuplicateCooperators({ visible, listaCooperados, onOk }) {
  const list = Array.isArray(listaCooperados) ? listaCooperados.filter((str) => str !== '') : [];

  const handleCopy = () => {
    clipboard(list.join('\n').replaceAll(',', '\n'));
    message.info('Informações copiadas');
  };

  return (
    <Modal
      title="Cooperados Duplicados"
      width={560}
      okText="Fechar"
      cancelButtonProps={{ style: { display: 'none' } }}
      open={visible}
      onOk={onOk}
    >
      <p>
        O CPF ou a Matrícula dos cooperados abaixo está duplicado(a) no arquivo importado. Unifique os dados e importe
        novamente.
      </p>
      <div>
        <ColaboradoresScroll>
          <ul>
            {list.map((str) => (
              <li key={str}>{str}</li>
            ))}
          </ul>
        </ColaboradoresScroll>
        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
          <Button
            type="link"
            role="button"
            onClick={handleCopy}
            style={{ padding: '8px', cursor: 'pointer', marginBottom: '1em' }}
          >
            Clique aqui para copiar o texto
          </Button>
        </div>
      </div>
    </Modal>
  );
}

ModalDuplicateCooperators.propTypes = {
  visible: PropTypes.bool,
  listaCooperados: PropTypes.arrayOf(PropTypes.string),
  onOk: PropTypes.func.isRequired,
};

ModalDuplicateCooperators.defaultProps = {
  visible: false,
  listaCooperados: [],
};
